// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_65eb455","currencyContainer":"_d56d031","title":"_7af62f4","currencyConvertor":"_779aa2d"};